export const msState = {
  teams: [],
  loading: true,
  activeId: false,
  displayUpArrow: false,
  floading: false,
  searchedTeam: false,
  searchedTName: "",
  sortOption: "",
  displayGeneralTab: false,
};

export const msReducer = (state, action) => {
  switch (action.type) {
    case "setFilterTeam":
      return { ...state, ...action.value };
    case "setTeams":
      return { ...state, teams: action.value };
    case "setLoading":
      return { ...state, loading: action.value };
    case "setActiveId":
      return { ...state, activeId: action.value };
    case "setDisplayArrow":
      return { ...state, displayUpArrow: action.value };
    case "setFilterLoading":
      return { ...state, floading: action.value };
    case "setTeamSearch":
      return { ...state, searchedTeam: action.value };
    case "setDisplayGeneralTab":
      return { ...state, displayGeneralTab: action.value };
    case "setSearchTName":
      return { ...state, searchedTName: action.value };
    case "setSortOption":
      return { ...state, sortOption: action.value };
    default:
      return state;
  }
};
